import * as api from 'config/axios';
import * as endpoints from './endpoints';

export const createRivirTC = (data) => {
  return api.sendPost(endpoints.CREATE_RIVIR_TC, data);
};

export const cloneRivirTC = (data) => {
  return api.sendPost(endpoints.CLONE_RIVIR_TC, data);
};

export const deleteRivirTC = (data) => {
  return api.sendPost(endpoints.DELETE_RIVIR_TC, data);
};

export const getUserRivirTC = (params) => {
  return api.sendGet(endpoints.GET_USER_RIVIR_TC, { params });
};

export const getRivirTCShortDetail = (data) => {
  return api.sendPost(endpoints.GET_RIVIR_TC_SHORT_DETAIL, data);
};

export const getRivirTCService = () => {
  return api.sendGet(endpoints.RIVIR_TC_GET_ENDPOINT);
};

export const acceptRivirTCService = (params) => {
  return api.sendPost(endpoints.RIVIR_TC_ACCEPT_ENDPOINT, params);
};

export const downloadRivirTCAccepted = (params) => {
  return api.sendPost(endpoints.EXPORT_RIVIR_TC_ACCEPTED, params);
};
